import { render, staticRenderFns } from "./EditPromotion.vue?vue&type=template&id=8e13a398"
import script from "./EditPromotion.vue?vue&type=script&lang=js"
export * from "./EditPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports